// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1IHJh","title":"Images45_title__3X7zi","images":"Images45_images__x3WcE"};